
/**
 * 주문 상태
 */
export type OrderInfoResponseStatus = typeof OrderInfoResponseStatus[keyof typeof OrderInfoResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderInfoResponseStatus = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
} as const;
